/**
 * @generated SignedSource<<3113135ae3d1344be6b53a45395279d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type useProductEligibilityCheckQuery$variables = {
  offerId: string;
  channel: CartChannel;
};
export type useProductEligibilityCheckQuery$data = {
  readonly productEligibility: {
    readonly isEligible: boolean;
  };
};
export type useProductEligibilityCheckQuery = {
  variables: useProductEligibilityCheckQuery$variables;
  response: useProductEligibilityCheckQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channel"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "channel",
            "variableName": "channel"
          },
          {
            "kind": "Variable",
            "name": "offerId",
            "variableName": "offerId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ProductEligibilityResponse",
    "kind": "LinkedField",
    "name": "productEligibility",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isEligible",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useProductEligibilityCheckQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useProductEligibilityCheckQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ba41a1b9c3b7a177333d424c0cb12d13",
    "id": null,
    "metadata": {},
    "name": "useProductEligibilityCheckQuery",
    "operationKind": "query",
    "text": "query useProductEligibilityCheckQuery(\n  $offerId: String!\n  $channel: CartChannel!\n) {\n  productEligibility(input: {offerId: $offerId, channel: $channel}) {\n    isEligible\n  }\n}\n"
  }
};
})();

(node as any).hash = "7062f31f946e807735ec874453a4a97f";

export default node;
